function About(){
return(
<section>
<h2>Sobre Mim</h2>
<p>
Sou estudante de Engenharia de Software, atualmente no 2º período, com foco em desenvolvimento de sistemas e soluções 
digitais. Possuo formação complementar em Desenvolvimento Full Stack, com conhecimentos em tecnologias 
como HTML, CSS, JavaScript, React.js, Node.js e banco de dados SQL. Busco constantemente aprimorar minhas 
habilidades técnicas e adquirir experiência prática na área de Tecnologia da Informação.
</p>
</section>
)
}

export default About
